module.exports = __webpack_public_path__ + "media/recipes/32-74647ce8.png";